import React from "react";

export const NotFound = () => {
  return <h2>NotFound</h2>;
};
